import { render, staticRenderFns } from "./BulkImageColorPanel.vue?vue&type=template&id=7ed3841b&scoped=true"
import script from "./BulkImageColorPanel.vue?vue&type=script&lang=js"
export * from "./BulkImageColorPanel.vue?vue&type=script&lang=js"
import style0 from "./BulkImageColorPanel.vue?vue&type=style&index=0&id=7ed3841b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3841b",
  null
  
)

export default component.exports